export const loadEnv = (variable: string): string => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const _window = window as any;
  return _window._env_
    ? _window._env_[variable]
      ? _window._env_[variable]
      : process.env[variable]
    : process.env[variable];
};
